<template lang="pug">
.layer.allow-replication(@click.self='handle', v-if='visiable', :class='[class_rel]')
  .content(:class='{ center: iscenter }', :style='{ maxWidth: maxWidth, width: width }')
    div(v-if='type')
      i.iconfont.toast(v-if='type === "success"', :class='type') &#xe644;
      i.iconfont.toast(v-else, :class='type') &#xe6b3;
    i.iconfont.close(v-if='showClose', @click.self='handle') &#xe60a;
    div
      slot
        p.title(v-if='!useHtml') {{ title }}
        p.desc(v-if='!useHtml') {{ desc }}
        p.title(v-if='useHtml', v-html='title')
        p.desc(v-if='useHtml', v-html='desc')
      div.select(v-if='tipText')
        i.icon-select(v-show="showCheckBox" :class='{active: selectActiveFlag}' @click='select')
        span(style="color: #ff6666;") {{tipText}}
    .button(v-if='showButton && cancelInLeft')
      kmbutton.diaKmButton(@click='cancel', v-if='showCancelButton', :isBorder='true') {{ cancelTxt }}
      kmbutton.diaKmButton(@click='confirm', :isBack='true') {{ confirmTxt }}{{ defaultClickTime ? '(' + defaultClickTime + 's)' :'' }}
    .button(v-if='showButton && !cancelInLeft')
      kmbutton.diaKmButton(@click='confirm', :isBorder='true') {{ confirmTxt }}{{ defaultClickTime ? '(' + defaultClickTime + 's)' :'' }}
      kmbutton.diaKmButton(@click='cancel', v-if='showCancelButton', :isBack='true') {{ cancelTxt }}
</template>

<script>
import Kmbutton from '../button/main'
export default {
  components: { Kmbutton },
  methods: {
    select() {
      this.selectActiveFlag = !this.selectActiveFlag
    },
    close() {
      clearInterval(this.time)
      this.callbackOnly()
      this.$destroy()
      this.$el.parentElement.removeChild(this.$el)
    },
    confirm() {
      clearInterval(this.time)
      this.callback(this.selectActiveFlag)
      this.close()
    },
    cancel() {
      this.cancelCall()
      this.close()
    },
    handle() {
      if (this.closeOnClickModal) {
        this.distinguishCancelAndClose ? this.close() : this.cancel()
      }
    },
  },
  data() {
    return {
      callbackOnly: () => {},
      tipText: '',
      cancelCall: '',
      callback: '',
      confirmTxt: '',
      cancelTxt: '',
      iscenter: '',
      showButton: '',
      cancelInLeft: true,
      type: '',
      title: '',
      desc: '',
      useHtml: false,
      showClose: true,
      closeOnClickModal: true,
      showCancelButton: '',
      visiable: '',
      class_rel: '123',
      distinguishCancelAndClose: true,
      maxWidth: 'inherit',
      width: 'auto',
      defaultClickTime: 0,
      selectActiveFlag: false,
      showCheckBox: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.visiable = true
      if (this.defaultClickTime) {
        this.time = setInterval(() => {
          this.defaultClickTime--
          if (this.defaultClickTime <= 0) {
            this.confirm()
          }
        }, 1000)
      }
    })
  },
}
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.layer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10010;
  .close {
    position: absolute;
    font-size: 20px;
    top: 6px;
    right: 6px;
    cursor: pointer;
  }
  background: rgba(0, 0, 0, 0.6);
  .content {
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 220px;
    min-width: 360px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content.center {
    text-align: center;
  }
  .button {
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
  i.success {
    color: #21bd73;
  }
  i.error {
    color: #ff6666;
  }
  i.warn {
    color: wheat;
  }
  i.toast {
    font-size: 60px;
  }
  i.confirm {
    display: none;
  }
  .title {
    min-height: 30px;
    font-size: 18px;
    color: #333;
  }
  .desc {
    margin-top: 20px;
    font-size: 16px;
    color: #666;
    min-height: 30px;
  }
  .diaKmButton {
    margin: 0 15px;
    min-width: 100px;
    padding: 0 10px !important;
    width: auto !important;
  }
  .select {
      width: 100%;
      margin-top: 30px;

      i.icon-select {
        display: inline-block;
        width: 16px;
        height: 16px;
        position: relative;
        top: 3px;
        background: url(/static/images/icon_common.png) no-repeat center;
        background-position: 0 0;
        cursor: pointer;

        &.active{
          background-position: -16px 0;
        }
      }

      & > span {
        margin-left: 10px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/messagebox/main.vue